import { CrmEndpoint, CrmEndpointListResponse } from 'common-module/endpoint';
import { Observable } from 'rxjs';

export class MediaEndpoint extends CrmEndpoint<any> {
  override list(options?: object): Observable<CrmEndpointListResponse<any>> {
    return this.client.get(this.endpoint, this.getReqOptions(options));
  }
}
